import { styled } from "@linaria/react";
import { ProgressSpinner } from "primereact/progressspinner";

const PProgressSpinner = styled(ProgressSpinner)<{ ref: React.LegacyRef<ProgressSpinner> }>``;

export const PProgressSpinnerStyle = {
  PProgressSpinner,
};
